<div class="full-width" fxLayout="column" fxLayoutGap="7px">
  <span class="body-3-default">{{ label }}</span>

  <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%;" hideRequiredMarker>
    <mat-select
      class="custom-select-field-value"
      [formControl]="control"
      [placeholder]="placeholder">
      <mat-option *ngFor="let item of items" [value]="item.code" class="custom-select-field-option">
        {{ item.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
